import React from "react";
import "./Blog.css";
import Techaccordion from "./Techaccordian";

function Blogdetail() {

  const frontend = [
    {
      id: 11,
      title: 'React JS',
      body: "Leverage our React software development services to build a project from start to go. Share your project requirements for the perfect mix of talent and expertise."
    },
    {
      id: 12,
      title: 'Angular JS',
      body: "Our Angular development company renders end-to-end Angular development services to both technical and outsourcing sectors. Whether you’re a startup or an enterprise-grade organization, our skilled Angular engineers will come up with incredible Angular solutions to bring life to your idea."
    },
    {
      id: 13,
      title: 'WordPress',
      body: "We design, develop and customize WordPress website that suits your needs. Our team has the capability to build bespoke WordPress website designs unique to your requirements and build custom features as per your demand."
    },
    {
      id: 14,
      title: 'Flutter',
      body: 'Our Flutter mobile app development services are devised to help you create a multi-platform existence. Right from finding the best product-market fit to seamlessly deploying your application across a number of platforms, our flutter developers can help you design, develop, test, and launch full-fledged Flutter apps.'
    },
    {
      id: 15,
      title: 'Android Development',
      body: "Android app development services comprise design, development, and enhancement of mobile software that runs on all supported Android OS versions. Targeting Android with native, hybrid, and cross-platform development, Aizonix Solutions always guarantees sustainable and seamless mobile experience."
    }
  ]

  const backend = [
    {
      id: 21,
      title: 'Django',
      body: 'As a specialist Django development company, our team has the skills and know-how required to meet your Django and Python development needs.'
    },
    {
      id: 22,
      title: 'Flask',
      body: 'At Aizonix Solutions, we have a team of Python experts that use Flask to build websites and custom applications for clients ranging from startups through to multinational companies.'
    },
    {
      id: 23,
      title: 'FastAPI',
      body: 'We are a trusted FastAPI development company that has been chosen by multiple companies across industries. We have an extensive portfolio of past clients thanks to our commitment to go beyond our clients’ expectations.'
    },
    {
      id: 24,
      title: 'Node JS',
      body: 'Our Node JS web development company implements tailored projects based on unique requirements. Boost your business with high-quality and powerful applications created from scratch.'
    },
    {
      id: 25,
      title: 'Laravel',
      body: 'At Aizonix Solutions, we work closely with our clients to create robust, scalable, aesthetically appealing, and feature-rich web applications to help them build a stronger online presence.'
    }
  ]

  return (
    <>
      <div className="container-fluid" style={{ backgroundColor: '#fff' }} id="Blog">
        <div style={{ backgroundColor: '#fff' }}>
          <h5 style={{ textAlign: "center", color: "#1E978C", paddingTop: "40px" }}> Technology</h5>
          <h1 >Technology We Offer</h1>
        </div>
        <div
          className="row"
          style={{ marginTop: "40px", paddingBottom: '30px' }}
        >
          <div className="col-sm-6 frontend">
            <h1>Frontend</h1>
            <Techaccordion title={frontend[0].title} body={frontend[0].body} key={frontend[0].id} />
            <Techaccordion title={frontend[1].title} body={frontend[1].body} key={frontend[1].id} />
            <Techaccordion title={frontend[2].title} body={frontend[2].body} key={frontend[2].id} />
            <Techaccordion title={frontend[3].title} body={frontend[3].body} key={frontend[3].id} />
            <Techaccordion title={frontend[4].title} body={frontend[4].body} key={frontend[4].id} />
          </div>
          <div className="col-sm-6">
            <h1>Backend</h1>
            <Techaccordion title={backend[0].title} body={backend[0].body} key={backend[0].id} />
            <Techaccordion title={backend[1].title} body={backend[1].body} key={backend[1].id} />
            <Techaccordion title={backend[2].title} body={backend[2].body} key={backend[2].id} />
            <Techaccordion title={backend[3].title} body={backend[3].body} key={backend[3].id} />
            <Techaccordion title={backend[4].title} body={backend[4].body} key={backend[4].id} />
          </div>
        </div>
      </div>
    </>
  );
}

export default Blogdetail;
